<template>
  <v-app class="bg-beige-0!">
    <RfCompanyContextIndicator />
    <RouterView></RouterView>
  </v-app>
</template>

<script setup>
import { onBeforeMount, onMounted, watch } from "vue";
import { useRoute, useRouter } from "vue-router";
import { useAppsStore } from "./pinia/appsStore";
import { useUserStore } from "./pinia/userStore";
import { RouterView } from "vue-router";
import RfCompanyContextIndicator from "./components/RfCompanyContextIndicator.vue";
import { useAppInit } from "@/utils/composables/useAppInit";

const route = useRoute();
const router = useRouter();
const appsStore = useAppsStore();
const userStore = useUserStore();

useAppInit();
onBeforeMount(() => userStore.getUser());
onMounted(async () => {
  await router.isReady();
  appsStore.getApps(route.params.aid);
});
watch(
  () => appsStore.app,
  app => {
    if (route.name === "Home" && app) {
      router.replace({ path: `/apps/${app.id}/dashboard` });
    }
  },
);
watch(route, (from, to) => {
  if (from.params.aid && to.params.aid && to.params.aid !== from.params.aid) {
    appsStore.selectApp(to.params.aid);
  }
});
</script>
